
import {defineComponent} from "vue";
import {Exception} from "@/api/interfaces";
import {arrayHasContent} from "@/helpers/functions/arrays";
import ProductsOverviewItem from "@/components/layouts/catalog/customer-products/ProductsOverviewItem.vue";
import CatalogBuildStatus from "@/components/layouts/catalog/CatalogBuildStatus.vue";
import BaseTitle from "@/components/UI/BaseTitle.vue";
import {FormMixin} from "@/components/base/FormMixin";
import AlertError2 from "@/components/UI/Bootstrap/Alert/AlertError2.vue";
import {
  PagedCustomerProductWithImageOverviewRestDtoModel
} from "@/models/api/pharma-cpc-product-mgmt/PagedCustomerProductWithImageOverviewRestDtoModel";
import {CustomerProductsRestService} from "@/services/rest/cpc-product-mgmt/CustomerProductsRestService";
import {I18nContext} from "@/context/I18nContext";

export default defineComponent({
  name: "CustomerProductsOverview",
  mixins: [FormMixin],
  components: {AlertError2, BaseTitle, CatalogBuildStatus, ProductsOverviewItem},
  data() {
    return {
      exceptions: [] as Exception[],
      tableHeaderItems: [this.$t('image'), this.$t('name'), this.$t('cnkCode'), this.$t('priceInclVat'), this.$t('vatPercentage'), this.$t('status'), ''] as string[],
      products: PagedCustomerProductWithImageOverviewRestDtoModel.createWithDefaults(),
    }
  },
  mounted() {
    this.initialize();
  },
  computed: {
    hasProducts(): boolean {
      return arrayHasContent(this.products.results);
    }
  },
  methods: {
    async doInitialize(): Promise<void> {
      // No implementation needed
    },
    async doReload(): Promise<void> {
      this.products = await CustomerProductsRestService.getInstance().findCustomerProducts(I18nContext.getDefaultLanguage());
    },
    async doDeleteItemWithKey(productCode: string) {
      await CustomerProductsRestService.getInstance().deleteCustomerProduct(productCode);
    }
  }
});
